import { useEffect, useRef, useState } from "react";

const useDebouncedValue = (val?: any, delay = 500) => {
  const [debouncedValue, setDebouncedValue] = useState(val);
  const timerRef = useRef<any>(null);

  useEffect(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      setDebouncedValue(val);
    }, delay);

    return () => {
      clearTimeout(timerRef.current);
    };
  }, [val]);

  return debouncedValue;
};

export default useDebouncedValue;
